"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreRegisterDataResultDto = void 0;
class PreRegisterDataResultDto {
}
exports.PreRegisterDataResultDto = PreRegisterDataResultDto;
//# sourceMappingURL=pre-register-data-result-dto.js.map